import * as Api from '../../../api/Api';
import { useState } from 'react';
import PermissionsGate from '../../../api/PermissionsGate';
import { SCOPES } from '../../../config/permissions-map';
import { Unauthorized } from '../../Global/unauthorized';
import { useGetToken } from '../../../Hooks/CustomHooks';
import * as Utilities from '../../../Components/Utils/Utils';
import { PageTitle } from '../../../../_metronic/layout/core';
import makeAnimated from 'react-select/animated';
import Select from 'react-select';
// import DatePicker from 'react-datepicker';
import { registerLocale } from 'react-datepicker';
import es from "date-fns/locale/es";
import lodash from "lodash";
import AgTable from '../../../Components/Table/AgTable';
import DatePicker from "react-date-picker"
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';

export default function VentasDiarias({ title }) {

    const currentDate = new Date(),
        previousDate = new Date();
    previousDate.setDate(currentDate.getDate() - 1);

    const [date, setDate] = useState(previousDate);
    const [dateTemp, setDateTemp] = useState(previousDate);
    let dateFormated = Utilities.formaterDate((date) ? date : dateTemp);
    registerLocale("es", es);

    const lastDate = lodash.cloneDeep((date) ? date : dateTemp);
    lastDate.setFullYear(Utilities.getAnioComparativo());
    let lastDateFormated = Utilities.formaterDate(lastDate);


    const animatedComponents = makeAnimated();

    const [inflacion, setInflacion] = useState(false)

    const [unidadEconomica, setUnidadEconomica] = useState(Utilities.getListUnidadesEconomicas().list[0]);
    let unidadesEconomicasList = Utilities.getListUnidadesEconomicas();

    const [tipoVenta, setTipoVenta] = useState({
        "value": "ventaDia",
        "label": "Venta del día"
    });
    let tipoVentaList = {
        "defaultId": "ventaDia",
        "list": [
            {
                "value": "ventaDia",
                "label": "Venta del día"
            },
            {
                "value": "ventaDiaAcumulada",
                "label": "Venta del día acumulada"
            },
            {
                "value": "ventaDiaM2",
                "label": "Venta del día m2"
            },
            {
                "value": "ventaDiaM2Acumulado",
                "label": "Venta del día m2 acumulado"
            }]
    };

    const getOptionValueUnidadEconomica = idDefault => {
        return unidadesEconomicasList.list.filter(obj => obj.value === idDefault)
    }

    const onChangeUnidadEconomica = (inputValue) => {
        setUnidadEconomica(inputValue);
    }

    const getOptionValuetipoVenta = idDefault => {
        return tipoVentaList.list.filter(obj => obj.value === idDefault)
    }

    const onChangeTipoventas = (inputValue) => {
        //setEnableQuery(true); //Everytime the select changes, it enables the useQuery condition for ChartFromServer
        setTipoVenta(inputValue);
    }

    const onChangeInflacion = () => {
        setInflacion(!inflacion);
    }


    let header = [
        {
            headerName: 'Unid Eco',
            field: 'unidEco',
        },
        {
            headerName: 'Mall',
            field: 'mall',
        },
        {
            headerName: 'Código',
            field: 'codigo',
        },
        {
            headerName: 'Descripción',
            field: 'descripcion',
        },
        {
            headerName: dateFormated,
            field: 'fechaCorte',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.fechaCorte, true, 2)}</>
            )
        },
        {
            headerName: lastDateFormated,
            field: 'fechaAnioAnterior',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.fechaAnioAnterior, true, 2)}</>
            )
        },
        {
            headerName: 'Dif(S/)',
            field: 'diferenciaValor',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.diferenciaValor, true, 2)}</>
            )
        },
        {
            headerName: 'Dif (%)',
            field: 'diferenciaPorcentaje',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.setClassDiferenceTable(props.data.diferenciaPorcentaje)}</>
            )
        }
    ];

    const [enableQuery, setEnableQuery] = useState(true);

    const token = useGetToken();

    return (
        <>
            <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.VENTAS_POR_DIA]} >
                <PageTitle>{title}</PageTitle>
                <div className="card my-5">
                    <div className="card-header border-0 pt-6 row g-3 flex-wrap d-flex flex-row">
                        <div className="col-12 col-sm-6 col-md-3">
                            <div className="fw-bold fs-7 text-gray-600 mb-1">Tipo Ventas:</div>
                            <Select
                                classNamePrefix='filter'
                                components={animatedComponents}
                                defaultValue={getOptionValuetipoVenta(tipoVentaList.defaultId)}
                                isMulti={false}
                                closeMenuOnSelect={true}
                                options={tipoVentaList.list}
                                onChange={(onChangeTipoventas)}
                            />
                        </div>

                        <div className="col-12 col-sm-6 col-md-3">
                            <div className="fw-bold fs-7 text-gray-600 mb-1">Mall:</div>
                            <Select
                                classNamePrefix='filter'
                                components={animatedComponents}
                                defaultValue={getOptionValueUnidadEconomica(unidadesEconomicasList.defaultId)}
                                isMulti={false}
                                closeMenuOnSelect={true}
                                options={unidadesEconomicasList.list}
                                onChange={(onChangeUnidadEconomica)}
                            />
                        </div>

                        <div className='col-12 col-sm-6 col-md-3'>
                            <div className="fw-bold fs-7 text-gray-600 mb-1">Fecha:</div>
                            <DatePicker
                                className="form-control form-control-transparent fit-content-width"
                                locale="es"
                                value={date}
                                onChange={(dateRange) => {
                                    setDate(dateRange);
                                    if (dateRange) {
                                        setDateTemp(dateRange)
                                    }
                                }}
                                format="dd/MM/y"
                            />
                        </div>

                        <div className='col-12 col-sm-6 col-md-3'>
                            <div className='p-2 inflacion form-check form-switch form-switch-sm form-check-custom form-check-solid'>
                                <input
                                    className='form-check-input'
                                    type='checkbox'
                                    name='inflacion'
                                    defaultChecked={false}
                                    onChange={(onChangeInflacion)}
                                />
                                <label className='form-check-label'>Inflación</label>
                            </div>
                        </div>

                    </div>

                    <div className="card-body tab-content pt-0">
                        <AgTable
                            idContent={"VentasDiarias" + dateFormated + inflacion + unidadEconomica.label + tipoVenta.value}
                            apiService={Api.VentasDiarias}
                            setAuxData={null}
                            header={header}
                            titleExcel={"VentasDiarias " + dateFormated + " " + inflacion + " " + unidadEconomica.label + " " + tipoVenta.value}
                            conditions={true}
                            args={{
                                fechaCorte: dateFormated,
                                token: useGetToken(),
                                tipoVenta: tipoVenta.value,
                                unidadEconomicaId: unidadEconomica.value,
                                // tipoClasificacion: tipoClasificacion.value,
                                inflacion: inflacion
                            }}
                            hideFilter={false}
                            paginationPageSize={8}
                            rowHeight={40}
                            useFlex={false}
                        />
                    </div>
                </div>
            </PermissionsGate>
        </>
    )
}